import { FC, RefObject } from 'react';

import { Icon } from '@purpur/library/icon';
import { close } from '@purpur/library/icon/assets/close';
import { menu } from '@purpur/library/icon/assets/menu';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { StyledBurgerButton } from './BurgerMenu.styles';

type Props = {
    ref: RefObject<HTMLButtonElement>;
    menuId: string;
    isOpen: boolean;
    onOpenToggle: () => void;
};

export const BurgerButton: FC<Props> = ({ ref, isOpen, onOpenToggle, menuId }) => {
    const { t } = useTranslations();

    return (
        <StyledBurgerButton
            ref={ref}
            $isOpen={isOpen}
            type="button"
            onClick={onOpenToggle}
            data-test={NAVIGATION_TEST_IDS.BURGER_BUTTON}
            aria-label={t['navbar.burger.aria_label']}
            aria-haspopup="true"
            aria-controls={menuId}
            aria-expanded={isOpen}
        >
            <Icon size="lg" svg={isOpen ? close : menu} />
        </StyledBurgerButton>
    );
};
